/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import { Random } from "random-js";
import axios from '@/axios.js'
import con from '@/firebase/firebaseInit.ts'
import firebase from 'firebase';
import ls from "@/common/localStorage"

var cn = ls.getSessionEventCollectionName();
const floormapRef = con.eventDB.collection(cn).doc('FloorMap').collection('FloormapList')
const storageRef = con.storageRef
var Session_Client_Id = ls.getSessionValueByKey('Session_Client_Id');
var Session_Event_Id = ls.getSessionValueByKey('Session_Event_Id');
var UploadFilesAPI = con.UploadFilesAPI;
var getAllFloorMapsAPI = con.getAllFloorMapsAPI;
var getFloorMapDetailAPI = con.getFloorMapDetailAPI;
var saveFloorMapAPI = con.saveFloorMapAPI;
var getAllBoothMapsAPI = con.getAllBoothMapsAPI;
var getBoothMapDetailAPI = con.getBoothMapDetailAPI;
var saveBoothMapAPI = con.saveBoothMapAPI;
var getAllRootMapsAPI = con.getAllRootMapsAPI;
var getRootMapDetailAPI = con.getRootMapDetailAPI;
var saveRootMapAPI = con.saveRootMapAPI;

export default {
    fetchFloorMaps({ commit }) {
        return new Promise((resolve, reject) => {      
          let headers = {
              "Content-Type": "application/json",
              'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`,
              "instanceId": "OA_UAT",
              "clientId": Session_Client_Id,
              "eventId": Session_Event_Id
          }

          axios.get(getAllFloorMapsAPI, { headers: headers }).then(function (res) {
            if(res.data.status == 0){
                commit('SET_FLOORMAPS', res.data.results)
                resolve(res.data.results) 
            }else{
                commit('SET_FLOORMAPS', [])
                resolve([])
            }
          }).catch(err=>{ reject(err) })
             
        })
    },
    fetchFloorMap(context, id) {
        return new Promise((resolve, reject) => {
            if (id === null) {
                resolve({
                    status: 200,
                    data: {
                        FlooreMapDisplayOrder: 1,
                        MapImage: '',
                        Name: '',
                        Venue: '',
                        IsPublished: true,
                        TotalHeight: 0,
                        TotalWidth: 0
                    }
                })
            } else {
                let headers = {
                      "Content-Type": "application/json",
                      'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`,
                      "instanceId": "OA_UAT",
                      "clientId": Session_Client_Id,
                      "eventId": Session_Event_Id
                  }

                  axios.get(`${getFloorMapDetailAPI}?mapId=${id}`, { headers: headers }).then(function (res) {
                    if(res.data.status == 0){
                        resolve({status: 200, data: res.data.result }) ;
                    }else{
                        resolve({status: 500, data: null }) ;
                    }
                  }).catch(err=>{ reject(err) })
            }
        })
    },
    updateFloorMap(context, field) {
        return new Promise((resolve, reject) => {
            let docObj = {
                    FlooreMapDisplayOrder: Number(field.data.FlooreMapDisplayOrder),
                    MapImage: field.data.MapImage,
                    Name: field.data.Name,
                    Venue: field.data.Venue,
                    //IsPublished: field.IsPublished,
                    TotalHeight: field.data.TotalHeight,
                    TotalWidth: field.data.TotalWidth,
                    //LastModifiedDate: new Date()
                }

            /*floormapRef.doc(`${field.id}`).update(docObj).then(function(doc) {
                resolve({ status: 200, message: 'Data Updated.' })        
            }).catch(function(error) {
                //console.log('Error getting update attendee:', error)
                reject(error)
            })*/
            let headers = {
                      "Content-Type": "application/json",
                      'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`,
                      "instanceId": "OA_UAT",
                      "clientId": Session_Client_Id,
                      "eventId": Session_Event_Id
                  }
                let requestData = {
                    key:{ id: field.id },
                    data: docObj
                }

              axios.put(saveFloorMapAPI, requestData, { headers: headers }).then(function (res) {
                if(res.data.status == 0){
                    resolve({status: 200, message: "Data Updated Successfully." }) ;
                }else{
                    resolve({status: 200, message: "Data Not Updated!" }) ;
                }
              }).catch(err=>{ reject(err) })
        })
    },
    addFloorMap(context, field) {   
        return new Promise((resolve, reject) => {
                //let floormapId = "RT" + new Date().getTime();    
                    let docObj = {
                        FlooreMapDisplayOrder: Number(field.data.FlooreMapDisplayOrder),
                        MapImage: field.data.MapImage,
                        Name: field.data.Name,
                        Venue: field.data.Venue,
                        IsPublished: true,
                        TotalHeight: field.data.TotalHeight,
                        TotalWidth: field.data.TotalWidth,
                        //CreatedDate: new Date(),
                        //LastModifiedDate: new Date()
                    }
                    /*context.dispatch('getAutoId').then(FloorMapId => {
                        docObj.FloorMapId = FloorMapId;
                        floormapRef.doc(`${docObj.FloorMapId}`).set(docObj).then(function() {
                            resolve({ status: 200, message: 'Data Added.', Id: FloorMapId })
                        }).catch(function(error) {
                            reject(error)
                        })
                    });*/
                    let headers = {
                          "Content-Type": "application/json",
                          'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`,
                          "instanceId": "OA_UAT",
                          "clientId": Session_Client_Id,
                          "eventId": Session_Event_Id
                      }
                    let requestData = {
                        data: docObj
                    }

                  axios.post(saveFloorMapAPI, requestData, { headers: headers }).then(function (res) {
                    if(res.data.status == 0){
                        resolve({status: 200, message: "Data Added Successfully." }) ;
                    }else{
                        resolve({status: 200, message: "Data Not Added!" }) ;
                    }
                  }).catch(err=>{ reject(err) })
                

        })
    },
    changeStatus(context, field) {
        return new Promise((resolve, reject) => {
            let headers = {
                      "Content-Type": "application/json",
                      'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`,
                      "instanceId": "OA_UAT",
                      "clientId": Session_Client_Id,
                      "eventId": Session_Event_Id
                  }
                let requestData = {
                    key:{ id: field.id },
                    data: { IsPublished: field.IsPublished }
                }

              axios.put(saveFloorMapAPI, requestData, { headers: headers }).then(function (res) {
                if(res.data.status == 0){
                    resolve({status: 200, message: "Status Changed Successfully." }) ;
                }else{
                    resolve({status: 200, message: "Status Not Changed!" }) ;
                }
              }).catch(err=>{ reject(err) })
        })
    },
    uploadFiles(context, field){
        return new Promise((resolve, reject) => {
            let accessToken = ls.getSessionValueByKey('Session_AccessToken');
            let headers = {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${accessToken}`
            }
            let requestData = {   
                "key": {
                    "instanceId": "OA_UAT",
                    "clientId": Session_Client_Id,
                    "eventId": Session_Event_Id,
                },                     
                files: field
            };
            axios.post(UploadFilesAPI, requestData, { headers: headers }).then(function (res) {
                if(res.data.status == 0)
                    resolve({status:200, data:res.data.data})
                else
                    resolve({status:500, data:[]})
            }).catch(err=>{ reject(err) })
        })
    },
    fetchBoothMaps({ commit }) {
        return new Promise((resolve, reject) => {      
          let headers = {
              "Content-Type": "application/json",
              'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`,
              "instanceId": "OA_UAT",
              "clientId": Session_Client_Id,
              "eventId": Session_Event_Id
          }

          axios.get(getAllBoothMapsAPI, { headers: headers }).then(function (res) {
            if(res.data.status == 0){
                commit('SET_BOOTHMAPS', res.data.results)
                resolve(res.data.results) 
            }else{
                commit('SET_BOOTHMAPS', [])
                resolve([])
            }
          }).catch(err=>{ reject(err) })
             
        })
    },
    fetchBoothMap(context, id) {
        return new Promise((resolve, reject) => {
            if (id === null) {
                resolve({
                    status: 200,
                    data: {
                        Left: 0,
                        Top: 0,
                        Right: 0,
                        Bottom: 0,
                        Width: 0,
                        Hight: 0,
                        Name: null,
                        Description: null,
                        EntityType: 1,
                        ParentID: null,
                        ID: null
                    }
                })
            } else {
                let headers = {
                      "Content-Type": "application/json",
                      'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`,
                      "instanceId": "OA_UAT",
                      "clientId": Session_Client_Id,
                      "eventId": Session_Event_Id
                  }

                  axios.get(`${getBoothMapDetailAPI}?bmapId=${id}`, { headers: headers }).then(function (res) {
                    if(res.data.status == 0){
                        resolve({status: 200, data: res.data.result }) ;
                    }else{
                        resolve({status: 500, data: null }) ;
                    }
                  }).catch(err=>{ reject(err) })
            }
        })
    },
    addBoothMap(context, field) {   
        return new Promise((resolve, reject) => {
                let docObj = {
                    Left: field.data.Left,
                    Top: field.data.Top,
                    Right: field.data.Right,
                    Bottom: field.data.Bottom,
                    Width: field.data.Width,
                    Hight: field.data.Hight,
                    Name: field.data.Name,
                    Description: field.data.Description,
                    EntityType: field.data.EntityType,
                    ParentID: field.data.ParentID,
                    ID: null,
                    IsPublished: true
                }
                let headers = {
                      "Content-Type": "application/json",
                      'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`,
                      "instanceId": "OA_UAT",
                      "clientId": Session_Client_Id,
                      "eventId": Session_Event_Id
                  }
                let requestData = {
                    data: docObj
                }

              axios.post(saveBoothMapAPI, requestData, { headers: headers }).then(function (res) {
                if(res.data.status == 0){
                    resolve({status: 200, message: "Data Added Successfully." }) ;
                }else{
                    resolve({status: 200, message: "Data Not Added!" }) ;
                }
              }).catch(err=>{ reject(err) })
                

        })
    },
    updateBoothMap(context, field) {
        return new Promise((resolve, reject) => {
            let docObj = {
                    Left: field.data.Left,
                    Top: field.data.Top,
                    Right: field.data.Right,
                    Bottom: field.data.Bottom,
                    Width: field.data.Width,
                    Hight: field.data.Hight,
                    Name: field.data.Name,
                    Description: field.data.Description,
                    EntityType: field.data.EntityType,
                }

            let headers = {
                      "Content-Type": "application/json",
                      'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`,
                      "instanceId": "OA_UAT",
                      "clientId": Session_Client_Id,
                      "eventId": Session_Event_Id
                  }
                let requestData = {
                    key:{ id: field.id },
                    data: docObj
                }

              axios.put(saveBoothMapAPI, requestData, { headers: headers }).then(function (res) {
                if(res.data.status == 0){
                    resolve({status: 200, message: "Data Updated Successfully." }) ;
                }else{
                    resolve({status: 200, message: "Data Not Updated!" }) ;
                }
              }).catch(err=>{ reject(err) })
        })
    },
    changeStatusBoothmap(context, field) {
        return new Promise((resolve, reject) => {
            let headers = {
                      "Content-Type": "application/json",
                      'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`,
                      "instanceId": "OA_UAT",
                      "clientId": Session_Client_Id,
                      "eventId": Session_Event_Id
                  }
                let requestData = {
                    key:{ id: field.id },
                    data: { IsPublished: field.IsPublished }
                }

              axios.put(saveBoothMapAPI, requestData, { headers: headers }).then(function (res) {
                if(res.data.status == 0){
                    resolve({status: 200, message: "Status Changed Successfully." }) ;
                }else{
                    resolve({status: 200, message: "Status Not Changed!" }) ;
                }
              }).catch(err=>{ reject(err) })
        })
    },
    fetchRootMaps({ commit }) {
        return new Promise((resolve, reject) => {      
          let headers = {
              "Content-Type": "application/json",
              'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`,
              "instanceId": "OA_UAT",
              "clientId": Session_Client_Id,
              "eventId": Session_Event_Id
          }

          axios.get(getAllRootMapsAPI, { headers: headers }).then(function (res) {
            if(res.data.status == 0){
                commit('SET_ROOTMAPS', res.data.results)
                resolve(res.data.results) 
            }else{
                commit('SET_ROOTMAPS', [])
                resolve([])
            }
          }).catch(err=>{ reject(err) })
             
        })
    },
    fetchRootMap(context, id) {
        return new Promise((resolve, reject) => {
            if (id === null) {
                resolve({
                    status: 200,
                    data: {
                        BoothIDEnd: null,
                        BoothIDStart: null,
                        Coordinates: [
                            {
                                Name: "",
                                X: null,
                                Y: null
                            },
                            {
                                Name: "",
                                X: null,
                                Y: null
                            }
                        ],
                        ID: null,
                        Name: null,
                        ParentID: null
                    }
                })
            } else {
                let headers = {
                      "Content-Type": "application/json",
                      'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`,
                      "instanceId": "OA_UAT",
                      "clientId": Session_Client_Id,
                      "eventId": Session_Event_Id
                  }

                  axios.get(`${getRootMapDetailAPI}?rmapId=${id}`, { headers: headers }).then(function (res) {
                    if(res.data.status == 0){
                        resolve({status: 200, data: res.data.result }) ;
                    }else{
                        resolve({status: 500, data: null }) ;
                    }
                  }).catch(err=>{ reject(err) })
            }
        })
    },
    addRootMap(context, field) {   
        return new Promise((resolve, reject) => {
                let docObj = {
                    SourceBooth: field.data.SourceBooth,
                    DestinationBooth: field.data.DestinationBooth,
                    BoothIDEnd: field.data.BoothIDEnd,
                    BoothIDStart: field.data.BoothIDStart,
                    Coordinates: field.data.Coordinates,
                    ID: null,
                    Name: field.data.Name,
                    ParentID: field.data.ParentID,
                    IsPublished: true
                  }
                let headers = {
                      "Content-Type": "application/json",
                      'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`,
                      "instanceId": "OA_UAT",
                      "clientId": Session_Client_Id,
                      "eventId": Session_Event_Id
                  }
                let requestData = {
                    data: docObj
                }

              axios.post(saveRootMapAPI, requestData, { headers: headers }).then(function (res) {
                if(res.data.status == 0){
                    resolve({status: 200, message: "Data Added Successfully." }) ;
                }else{
                    resolve({status: 200, message: "Data Not Added!" }) ;
                }
              }).catch(err=>{ reject(err) })
                

        })
    },
    updateRootMap(context, field) {
        return new Promise((resolve, reject) => {
            let docObj = {
                    SourceBooth: field.data.SourceBooth,
                    DestinationBooth: field.data.DestinationBooth,
                    BoothIDEnd: field.data.BoothIDEnd,
                    BoothIDStart: field.data.BoothIDStart,
                    Coordinates: field.data.Coordinates,
                    Name: field.data.Name,
                  }

            let headers = {
                      "Content-Type": "application/json",
                      'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`,
                      "instanceId": "OA_UAT",
                      "clientId": Session_Client_Id,
                      "eventId": Session_Event_Id
                  }
                let requestData = {
                    key:{ id: field.id },
                    data: docObj
                }

              axios.put(saveRootMapAPI, requestData, { headers: headers }).then(function (res) {
                if(res.data.status == 0){
                    resolve({status: 200, message: "Data Updated Successfully." }) ;
                }else{
                    resolve({status: 200, message: "Data Not Updated!" }) ;
                }
              }).catch(err=>{ reject(err) })
        })
    },
    changeStatusRootmap(context, field) {
        return new Promise((resolve, reject) => {
            let headers = {
                      "Content-Type": "application/json",
                      'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`,
                      "instanceId": "OA_UAT",
                      "clientId": Session_Client_Id,
                      "eventId": Session_Event_Id
                  }
                let requestData = {
                    key:{ id: field.id },
                    data: { IsPublished: field.IsPublished }
                }

              axios.put(saveRootMapAPI, requestData, { headers: headers }).then(function (res) {
                if(res.data.status == 0){
                    resolve({status: 200, message: "Status Changed Successfully." }) ;
                }else{
                    resolve({status: 200, message: "Status Not Changed!" }) ;
                }
              }).catch(err=>{ reject(err) })
        })
    },
}